
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import base64 from 'vux/src/tools/base64/index.js'
import AlertModule from 'vux/src/plugins/alert/module'


import fetch from './fetchDataPage'


export default {
data(){
return {
userName:'',
password:'',
userInfo:{}
}
},
components:{
Group,
Cell,
XInput,
XButton,
base64,
AlertModule

},
methods:{

loginV2(flag){
let params = {
userName:this.userName,
pwd:base64.encode(this.password),
domain:"https://e.ausnutria.com"
}
fetch.login({params:params}).then(res=>{
this.userInfo = res.data
localStorage.userInfo = JSON.stringify(this.userInfo);
this.$store.commit('INIT_USER_INFO')
this.$router.push('DevHome');





}).catch(err=>{

})
},
findGuideInfo(){
let params = {
guideEmpNo:this.userInfo.userName
}
fetch.oaHrGuideRService_findGuideInfo({params:params}).then(res=>{

try {
localStorage.guideInfo = JSON.stringify(res.data);

if(res.data && res.data.guideRMapShops && res.data.guideRMapShops.length>=1){
localStorage.shopInfo = JSON.stringify(res.data.guideRMapShops[0]);
}
this.$store.commit('INIT_USER_INFO')
this.$store.commit('INIT_GUIDE_INFO')
this.$store.commit('INIT_SHOP_INFO')
this.$router.push({name:'/'});
} catch (error) {
alert('登陆失败，检查数据')
}

}).catch(err=>{

})
},
listLookupValues() {
debugger
fetch.baseLookupTypeService_findDic().then(res=>{
let obj = {}
res.data.map((item)=>{
if(!obj[item.lookupType]){
obj[item.lookupType] = []
}
obj[item.lookupType].push(item)
})
localStorage.lookupValues = JSON.stringify(obj);
this.$store.commit('SET_LOOKUP')
})
}
},
mounted() {
debugger
this.listLookupValues()
}
}



// WEBPACK FOOTER //
// ./src/page/Login.vue